<template>
  <div class="wage-work-type-setting">
    <div class="title">工种工资上限设置</div>
    <el-row class="op" justify="space-between">
      <div>
        <el-input v-model="params.workType" placeholder="输入工种搜索" autocomplete="false" style="width:200px;margin-right:15px"
          clearable @change="searchData"></el-input>
        <el-button type="primary" @click="searchData" icon="search">搜索</el-button>

      </div>
      <div>        
        <el-button type="primary" @click="toEdit()" icon="circle-plus-filled">新增</el-button>
        <el-button type="primary" @click="toExport" icon="download">导出</el-button>
      </div>
    </el-row>

    <el-table :data="wageWorkTypes" tooltip-effect="dark" border stripe height="calc(100vh - 255px)" v-loading="loading">
      <el-table-column v-for="(column, index) in tableColumns" :key="index" :type="column.type" :prop="column.prop"
        :label="column.label" :width="column.width" :min-width="column.minWidth" :formatter="column.formatter"
        :fixed="column.fixed" :show-overflow-tooltip="column.tooltip">
      </el-table-column>
      <el-table-column label="操作" width="130" fixed="right">
        <template #default="{row}">
          <el-button type="text" @click="toEdit(row)">编辑</el-button>
          <el-button type="text" @click="toDelete(row)" style="color:red;">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="total"
      :current-page="params.pageNo" :page-size="params.length" @current-change="pageNoChange"
      @size-change="lengthChange">
    </el-pagination>
  </div>

  <wage-edit ref="wageEdit" @get-data="getData" />
</template>

<script>
import { defineComponent } from 'vue'
import wageEdit from './Edit.vue'
import { deleteWageWorkType, exportWageWorkType, getWageWorkTypeList } from '@/api/sys/wageWorkType'
import { exportFile } from '@/utils/fileUtil'

export default defineComponent({
  components: { wageEdit },
  data() {
    return {
      loading: false,
      wageWorkTypes: [],
      total: 0,
      tableColumns: [
        { type: 'index', width: 55, label: '序号', fixed: 'left' },
        { prop: 'workType', label: '工种', minWidth: 100, fixed: 'left', tooltip: true },
        { prop: 'salaryUpperLimit', label: '工资参考上限(元)', width: 170 },
        { prop: 'normalSalary', label: '正常工资(元)', width: 170 },
        { prop: 'overtimeSalary', label: '加班工资(元)', width: 170 },
        { prop: 'remarks', label: '备注', minWidth: 120, tooltip: true }
      ],
      params: {
        workType: null,
        pageNo: 1,
        length: 20
      }
    }
  },
  methods: {
    getData() {
      this.loading = true;
      getWageWorkTypeList(this.params).then(({data}) => {
        this.wageWorkTypes = data.data;
        this.total = data.page.totalRecords;
        this.loading = false;
      }).catch(_ => this.loading = false);
    },
    searchData() {
      this.params.pageNo = 1;
      this.getData();
    },
    pageNoChange(pageNo) {
      this.params.pageNo = pageNo;
      this.getData();
    },
    lengthChange(length) {
      this.params.length = length;
      this.searchData();
    },
    toEdit(wageWorkType) {
      this.$refs.wageEdit.toShow(wageWorkType);
    },
    toDelete(wageWorkType) {
      this.$confirm(`确定删除工种：${wageWorkType.worKType}的工资设置`, '提示').then(_ => {
        deleteWageWorkType(wageWorkType.id).then(({data}) => {
          if (data.status) {
            this.$message.success(data.msg);
            this.getData();
          } else {
            this.$message.warning(data.msg);
          }
        }).catch(_ => {})
      }).catch(_ => {})
    },
    toExport() {
      exportWageWorkType(this.params).then(res => {
        exportFile(res);
      }).catch(_ => {})
    }
  },
  mounted() {
    this.getData();
  }
})
</script>


<style lang="scss" scoped>
.wage-work-type-setting {
  padding: 15px;
  .title {
    font-size: 1.5em;
  }
  .op {
    margin: 15px 0;
  }
  .el-table {
    margin-bottom: 15px;
  }
}
</style>